// @flow
import React from 'react';
import { Query, type QueryRenderProps } from '@apollo/client/react/components';
import {
  type GetClientMonthlyDataData,
  type GetClientMonthlyDataVariables,
  type GetFeatureFlagResponse,
  type GetFeatureFlagVariables,
  FEATURE_FLAG_IS_ENABLED,
  GET_CLIENT_MONTHLY_DATA,
} from 'client-web-app/queries';
import { getCategorizeStatusForDate } from 'client-web-app/helpers';

import DataEntryStatus from './DataEntryStatus';
import TransactionSidebarDataEntryText from './TransactionSidebarDataEntryText';

type TransactionSidebarTransactionStatusContainerProps = {
  ledgerNameTestId: string,
  clientId: string,
  transactionDate: string,
  ledgerName: string,
  isCurrentLedger: boolean,
};

const TransactionSidebarDataEntryStatusContainer = ({
  ledgerNameTestId,
  clientId,
  transactionDate,
  ledgerName,
  isCurrentLedger,
}: TransactionSidebarTransactionStatusContainerProps) => (
  <Query
    query={FEATURE_FLAG_IS_ENABLED}
    variables={{ feature: 'showTransactionStatuses', clientId }}
  >
    {(
      getFeatureFlagIsEnabled: QueryRenderProps<GetFeatureFlagResponse, GetFeatureFlagVariables>,
    ) => (
      <Query query={GET_CLIENT_MONTHLY_DATA} variables={{ clientId }}>
        {(
          getClientMonthlyData: QueryRenderProps<
            GetClientMonthlyDataData,
            GetClientMonthlyDataVariables,
          >,
        ) => {
          if (getFeatureFlagIsEnabled.loading || getClientMonthlyData.loading) {
            return null;
          }

          const clientMonthlyData =
            getClientMonthlyData &&
            getClientMonthlyData.data &&
            getClientMonthlyData.data.client &&
            getClientMonthlyData.data.client.more &&
            getClientMonthlyData.data.client.more.monthlyData;

          const featureFlagEnabled =
            getFeatureFlagIsEnabled &&
            getFeatureFlagIsEnabled.data &&
            !!getFeatureFlagIsEnabled.data.featureEnabled &&
            getFeatureFlagIsEnabled.data.featureEnabled;

          const dataEntryCategorizeStatus =
            clientMonthlyData && getCategorizeStatusForDate(transactionDate, clientMonthlyData);

          const isDataEntryAutoPosted =
            !dataEntryCategorizeStatus ||
            ['CATEGORIZE', 'NOT_APPLICABLE', 'NOT_READY'].includes(dataEntryCategorizeStatus);

          const showDatEntryStatus =
            featureFlagEnabled &&
            isDataEntryAutoPosted &&
            !!clientMonthlyData &&
            !getClientMonthlyData.error &&
            !getFeatureFlagIsEnabled.error;

          if (showDatEntryStatus) {
            return (
              <DataEntryStatus
                ledgerName={ledgerName}
                showDarkButton={false}
                ledgerNameTestId={ledgerNameTestId}
              />
            );
          }
          return (
            <TransactionSidebarDataEntryText
              data-test-id={ledgerNameTestId}
              isCurrentLedger={isCurrentLedger}
            >
              {ledgerName}
            </TransactionSidebarDataEntryText>
          );
        }}
      </Query>
    )}
  </Query>
);

export default TransactionSidebarDataEntryStatusContainer;
